import { useTheme, ThemeKey } from "@/contexts/ThemeContext";
import commandxLogo from "@/assets/commandx-logo.png";
import logoDark from "@/assets/logo-dark.png";

const DARK_THEMES: ThemeKey[] = ["modern-dark", "terminal-dark", "terminal-amber", "blueprint", "high-contrast"];

/** Returns the correct CommandX logo variant based on the active theme. */
export function useCommandXLogo(): string {
  const { theme } = useTheme();
  return DARK_THEMES.includes(theme) ? logoDark : commandxLogo;
}
